import { useEffect } from 'react';

const useUpdateToolbarHeight = (toolbarHeight: number) => {
    useEffect(() => {
        document.body.style.setProperty('--modern-mobile-toolbar-height', `${toolbarHeight}px`);
    }, [toolbarHeight]);
};

export default useUpdateToolbarHeight;
